import { FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material';
import React, { useState } from 'react'
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setCause } from '../../../slices/causesSlice';
import { autoFillAddress, setTypeService } from '../../../slices/fillAddressSlice';


export const MainSelect = ( props ) => {
  const [value, setValue] = useState('')
  const dispatch = useDispatch()
  const { typeService } = useSelector(state => state.accounts)
  const handleChange = (e) => {
    setValue(e.target.value);
    dispatch(setCause(e.target.value))
  };
  
  return (
    <Grid item xs={ props?.columns }>
    <FormControl fullWidth className="input-radius" >
        <InputLabel id="demo-simple-select-label" sx={{ display: 'flex', alignItems: 'center', position: 'absolute', top: -5}}>{ props?.text }</InputLabel>
        <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            // value={value}
            label={props?.text}
            disabled={props?.disabled}
            onChange={handleChange}
            >
              {
               
                props?.data.map(({ id, cause }) => (
                  <MenuItem key={id} value={id}>{cause}</MenuItem>
                  ))
                
              }
        </Select>
    </FormControl>
    </Grid>
  )
}
